import type { EditorView } from '@codemirror/view'
import type { MutableRefObject } from 'react'
import { useEffect } from 'react'

/**
 * Synchronizes external value changes into the CodeMirror EditorView.
 * Only dispatches when the value differs from the last known external value.
 */
export const useEditorValueSync = (
  viewRef: MutableRefObject<EditorView | null>,
  value: string,
  lastExternalValueRef: MutableRefObject<string>
): void => {
  useEffect(() => {
    const view = viewRef.current
    if (!view) return
    if (value === lastExternalValueRef.current) return

    lastExternalValueRef.current = value
    const currentDoc = view.state.doc.toString()
    if (currentDoc === value) return

    view.dispatch({
      changes: { from: 0, to: currentDoc.length, insert: value },
    })
  }, [value, viewRef, lastExternalValueRef])
}
